export function arrayToMap<
    T extends Record<string, any>,
    TKey extends keyof T
>(array: T[], key: TKey): Record<T[TKey], T> {
    return array.reduce((res, item) => {
        if (item[key] != null) {
            res[item[key]] = item;
        }

        return res;
    }, {} as Record<T[TKey], T>);
}

export default arrayToMap;
